import React from "react";
import { Table, TableBody, TableRow, TableCell, List, ListItem } from "@mui/material";
import { tableCellBold, listItemBlock, tableCellKey, lastTableRowThickBorder } from "../../features/invoice/vendor/vendorInvoiceFileOutput/OutputInvoicePreviewStyles";

const ObjectTable = ({ obj }) => (
  (!obj || typeof obj !== "object" || Array.isArray(obj)) ? <span>—</span> :
    <Table size="small">
      <TableBody>
        {Object.entries(obj).map(([key, value], idx, arr) => {
          const isLast = idx === arr.length - 1;
          return (
            <TableRow key={key} sx={isLast ? lastTableRowThickBorder : {}}>
              <TableCell sx={tableCellKey}>{key}</TableCell>
              <TableCell>{String(value)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
);

const renderValue = (value) => {
  if (Array.isArray(value)) {
    return (
      <List dense>
        {value.map((item, idx) => (
          <ListItem key={idx} sx={listItemBlock}>
            {typeof item === "object" && item !== null ? (
              <ObjectTable obj={item} />
            ) : (
              String(item)
            )}
          </ListItem>
        ))}
      </List>
    );
  }

  if (typeof value === "object" && value !== null) {
    return <ObjectTable obj={value} />;
  }

  return String(value);
};

const JsonTable = ({ data }) => {
  if (!data || typeof data !== "object") return <div>No data to display</div>;

  return (
    <Table>
      <TableBody>
        {Object.entries(data).map(([key, value]) => (
          <TableRow key={key}>
            <TableCell sx={{ ...tableCellBold, verticalAlign: "top" }}>{key}</TableCell>
            <TableCell>{renderValue(value)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default JsonTable;
